module.exports = __webpack_public_path__ + "static/img/eye-c.18ee22e0.svg";